import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
} from "react-router-dom";
import Footer from "./components/home/Footer/Footer";
import Header from "./components/home/Header/Header";
import HeaderBottom from "./components/home/Header/HeaderBottom";
import SpecialCase from "./components/SpecialCase/SpecialCase";
import About from "./pages/About/About";
import SignIn from "./pages/Account/SignIn";
import SignUp from "./pages/Account/SignUp";
import Cart from "./pages/Cart/Cart";
import Contact from "./pages/Contact/Contact";
import Home from "./pages/Home/Home";
import Offer from "./pages/Journal/Offer";
import ProductDetails from "./pages/ProductDetails/ProductDetails";
import Shop from "./pages/Shop/Shop";
import Fans from './components/Fans'; 
import AC from './components/AC';
import Geyser from './components/Geyser';
import Dispenser from './components/Dispenser';
import Refrigerator from './components/Refrigerator';

import FansPrice from './components/FansPrice';
import GeyserPrice from './components/GeyserPrice';
import DispenserPrice from './components/DispenserPrice';
import RefrigeratorPrice from './components/RefrigeratorPrice';
import AcPrice from './components/AcPrice';
import PriceList from './components/PriceList';
import Checkout from './pages/payment/Checkout';
import Feedback from './pages/Feedback/Feedback';
import SimpleNavbar from "./components/home/Header/SimpleNavbar";







const Layout = () => {
  return (
    <div>
      <SimpleNavbar/>
      <Header />
      <HeaderBottom />
      <SpecialCase />
      <ScrollRestoration />
      <Outlet />
      <Footer />
    </div>
  );
};
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />}></Route>
        <Route path="/shop" element={<Shop />}></Route>
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/Offer" element={<Offer />}></Route>
        <Route path="/feedback" element={<Feedback />}></Route>
        <Route path="/products/fans" element={<Fans />}></Route>
        <Route path="/products/ac" element={<AC />}></Route>
        <Route path="/products/geyser" element={<Geyser />}></Route>
        <Route path="/products/dispenser" element={<Dispenser />}></Route>
        <Route path="/products/refrigerator" element={<Refrigerator />}></Route>
        <Route path="/pricelist/pricelist" element={<PriceList />}></Route>

        <Route path="/pricelist/fansprice" element={<FansPrice />}></Route>
        <Route path="/pricelist/acprice" element={<AcPrice />}></Route>
        <Route path="/pricelist/dispenserprice" element={<DispenserPrice />}></Route>
        <Route path="/pricelist/geyserprice" element={<GeyserPrice />}></Route>
        <Route path="/pricelist/refrigeratorprice" element={<RefrigeratorPrice />}></Route>
       
        <Route path="/offer" element={<Offer />}></Route>
        <Route path="/product/:_id" element={<ProductDetails />}></Route>
        <Route path="/cart" element={<Cart />}></Route>
        <Route path="/checkout" element={<Checkout />} />
      </Route>
      <Route path="/signup" element={<SignUp />}></Route>
      <Route path="/signin" element={<SignIn />}></Route>
    </Route>
  )
);

function App() {
  return (
    <div className="font-bodyFont">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
